<template>
    <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', textColor]" />
</template>

<script>
export default {
  name: 'CellRendererVerified',
  computed: {
    textColor () {
      if (this.params.value == 1) {
        return 'text-primary'
      }
      return 'text-grey'
    }
  }
}
</script>
